import { initLazyLoad, showModal3DDownload } from "@api/utils_2020";
//import Splide from '@splidejs/splide';
//import '@splidejs/splide/dist/css/splide-core.min.css';


let carousels = [];
let carIdx = 0;
const pbMyArchtrendsV2 = {
    archtrendsService: null,
    slugProfile: $('.dashboard-cards.archtrends').data('slugprofile'),
    limit: 5,
    init: function () {
        if ($('.no-projects').length == 0)
        {
            Util.service(archtrendsEndpoint + "/rpc/json/Archtrends_Service_Archtrends", true, {
                exceptionHandler: alertInterface.showError,
                reflectSuccess: function(service) {
                    pbMyArchtrendsV2.archtrendsService = service;
                    pbMyArchtrendsV2.listMostViewedProjectsByUser(pbMyArchtrendsV2.slugProfile, {2: pbMyArchtrendsV2.limit});
                    //$(".pb-myarchtrends .tags a").first().addClass("selected");
                }
            });
            /*
            $(".pb-myarchtrends .tags a").on("click", ev=> {
                ev.preventDefault();
                const selected = $(ev.target).attr("id")
                
                $(".pb-myarchtrends .tags a").toArray().forEach( elem => {
                    $(elem).removeClass("selected");
                });
                $(ev.target).addClass("selected");

                if(selected == "mostLiked") {
                    pbMyArchtrendsV2.listMostViewedProjectsByUser(pbMyArchtrendsV2.slugProfile, {2: pbMyArchtrendsV2.limit});
                } else  {
                    pbMyArchtrendsV2.listMostRecentProjectsByUser(pbMyArchtrendsV2.slugProfile, {2: pbMyArchtrendsV2.limit});
                }
            })
            */
        }        
        else
        {
   
        }
    },
   
    listMostViewedProjectsByUser: (slug, navigation = {}) => {
        $('.pb-specifier-header-v4 .cards-containers .dashboard-cards .list .pb-card').fadeOut().remove();
        pbMyArchtrendsV2.archtrendsService.listMostViewedProjectsByUser(slug, navigation, {
            success: ({results, total}) => {
                if(total > 0) {
                    UtilUi.loadTemplate("assets/components/pb-specifier-header-v4/pb-specifier-header-v4--archtrends-card.tpl", function(dataContact, tpl) {
                        console.log(results)

                        const html = tpl.fetch({
                            carrousel: results,
                            urlArchtrends: archtrendsEndpoint,
                            urlImageServer
                        });
        
                        $('.pb-specifier-header-v4 .cards-containers .dashboard-cards .list').append(html).hide().fadeIn();
                        initLazyLoad();
                    })
                }
            }
        })    
    },
    listMostRecentProjectsByUser: (slug, navigation) => {
        $('.pb-specifier-header-v4 .cards-containers .dashboard-cards .list .pb-card').fadeOut().remove();
        pbMyArchtrendsV2.archtrendsService.listMostRecentProjectsByUser(slug, navigation, {
            success: ({results, total}) => {
                if(total > 0) {
                    UtilUi.loadTemplate("assets/components/pb-specifier-header-v4/pb-specifier-header-v4--archtrends-card.tpl", function(dataContact, tpl) {
                        console.log(results)

                        const html = tpl.fetch({
                            carrousel: results,
                            urlArchtrends: archtrendsEndpoint,
                            urlImageServer                            
                        });
        
                        $('.pb-specifier-header-v4 .cards-containers .dashboard-cards .list').append(html).hide().fadeIn();
                        initLazyLoad();
                    })
                }
            }
        })
    }
}


export default () => {
    
    showModal3DDownload();

    pbMyArchtrendsV2.init();

    /*
    new Splide( '.splide' , {
        pagination: false,
        arrows: false,
        autoWidth: true,
        autoHeight: true,
        snap: true,
        drag: true,
//                lazyLoad: 'nearby',
        gap: "30px"
    } ).mount();*/

    /*
    $("#archtrendscarousel .pb-taggedcarousel-v2 .pb-carousel .pb-item").scheletrone();
    $("#gallerycarousel .pb-taggedcarousel-v2 .pb-carousel .pb-item").scheletrone();

    let service = Util.service(`${archtrendsEndpoint}/rpc/json/Archtrends_Service_Site`, true, {
        exceptionHandler: alertInterface.showError,
        reflectSuccess: function(service) {

            service.listCategories(null,{1:'name ASC'}, {
                success: (categoryList) => {
                    //$("#archtrendscarousel .pb-taggedcarousel ul.tags li").scheletrone();

                    if (categoryList && categoryList.results) {
                        categoryList.results.map((categoryItem) => {                            
                            $("#archtrendscarousel .pb-taggedcarousel-v2 ul.tags").append(`<li><a id="${categoryItem.id}" href="" class="pb-tag">${categoryItem.name}</a></li>`);
                           
                        });
                        //$("#archtrendscarousel .pb-taggedcarousel ul.tags li").scheletrone('stopLoader');
                        $("#archtrendscarousel .pb-taggedcarousel-v2 ul.tags a").on('click', function(e)
                        {
                            e.preventDefault();
                            $('#archtrendscarousel ul.tags a').removeClass('selected');
                            let idCategory = $(this).attr('id');
                            renderArchtrends(idCategory);
                            if (idCategory)
                            {
                                $('#archtrendscarousel ul.tags a[id="'+idCategory+'"]').addClass('selected');
                            }
                            else
                            {
                                $('#archtrendscarousel ul.tags a').first().addClass('selected');
                            }
                            return false;
                        });
                        $('#archtrendscarousel ul.tags a').first().addClass('selected');
                    }
                }
            }
            );

            $("#gallerycarousel .pb-taggedcarousel-v2 ul.tags a").on('click', function(e)
            {
                e.preventDefault();
                $('#gallerycarousel ul.tags a').removeClass('selected');
                let idGallery = $(this).attr('id');
                rendeGallery(idGallery);
                if (idGallery)
                {
                    $('#gallerycarousel ul.tags a[id="'+idGallery+'"]').addClass('selected');
                }
                else
                {
                    $('#gallerycarousel ul.tags a').first().addClass('selected');
                }
                return false;
            });

            $('#gallerycarousel ul.tags a').first().addClass('selected');

            const OPTION_LIMIT = 2;
            const navigation = {};
            navigation[OPTION_LIMIT] = 8;

            const renderArchtrends = function(category)
            {
                $("#archtrendscarousel .pb-taggedcarousel-v2 .pb-carousel .pb-item").scheletrone();
                
                //service.getActiveHighlightsByArea("projects", navigation, false, null, 10, {
                service.listProjectsByCategory([category],1,false,false,null, {
                    success: (highlights) => {
                        if (highlights && highlights.results) {
                            UtilUi.loadTemplate(
                                "assets/components/pb-taggedcarousel-v2/pb-item--archtrends-v2.tpl",
                                function(data, tpl) {
                                    $('#archtrendscarousel .pb-taggedcarousel-v2 .pb-carousel').slick('slickRemove', null, null, true);
                                    highlights.results.map((project) => {
                                        if (project.city && project.state)
                                            project.city += ', ' + project.state;
                                        const htmlContent = tpl.fetch({ card: project,  urlImageServer: urlImageServer, avatar: true });
                                        $("#archtrendscarousel .pb-taggedcarousel-v2 .pb-carousel").slick("slickAdd", htmlContent);
                                    });
                                    
                                    initLazyLoad();
                                    $("#archtrendscarousel .pb-taggedcarousel-v2 .pb-carousel .pb-item").scheletrone('stopLoader');
                                }
                            );
                            
                        }
                    },
                });
            }

            const rendeGallery = function (tag, category)
            {
                if (!tag)
                    tag = 1;
                category = null;
                let filter = null;
                $("#gallerycarousel .pb-taggedcarousel-v2 .pb-carousel .pb-item").scheletrone();
            
                service.searchProjectsWithTag(tag, '', category, filter, navigation, 8, {
                    success: (highlights) => {
                        if (highlights && highlights.results) {
                            UtilUi.loadTemplate(
                                "assets/components/pb-taggedcarousel-v2/pb-item--archtrends-v2.tpl",
                                function(data, tpl) {
                                    $('#gallerycarousel .pb-taggedcarousel-v2 .pb-carousel').slick('slickRemove', null, null, true);
                                    highlights.results.map((project) => {
                                        project.city = project.fullname;
                                        project.fullname = project.name;
                                        const htmlContent = tpl.fetch({ card: project,  urlImageServer: urlImageServer, avatar: false });
                                        $("#gallerycarousel .pb-taggedcarousel-v2 .pb-carousel").slick("slickAdd", htmlContent);
                                    });
                                    
                                    initLazyLoad();
                                    $("#gallerycarousel .pb-taggedcarousel-v2 .pb-carousel .pb-item").scheletrone('stopLoader');
                                }
                            );
                            
                        }
                    },
                });
            }

            renderArchtrends();
            rendeGallery();
        },
        reflectError: (error) => {
            console.log(error);
        },
    });  
    */
    
    $('body').on('click','a.jsOpenChat', function(e)
    {
       e.preventDefault();
       try {
            document.querySelector('.helpButtonEnabled').dispatchEvent(new Event('click', {
                'view': window,
                'bubbles': true,
                'cancelable': true
            }));
        }
        catch (ex)
        {
            $('#esw-fab').trigger('click');
        }
        $('#esw-fab').trigger('click');
        return false;
    });
}


